import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Receipt } from 'lucide-react';

export default function AdminFactura() {
    const [settings, setSettings] = useState({});
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = async () => {
        const [s, cs] = await Promise.all([api.get('/admin/settings'), api.get('/factura/config-status')]);
        setSettings(s.data || {});
        setStatus(cs.data);
    };
    useEffect(() => { load(); }, []);

    const save = async () => {
        setBusy(true);
        try {
            await api.put('/admin/settings', {
                factura_com_api_key: settings.factura_com_api_key || null,
                factura_com_secret_key: settings.factura_com_secret_key || null,
                factura_com_mode: settings.factura_com_mode || 'sandbox',
                factura_com_issuer_rfc: settings.factura_com_issuer_rfc || null,
                factura_com_issuer_name: settings.factura_com_issuer_name || null,
                factura_com_series: settings.factura_com_series || null,
            });
            toast.success('Configuración guardada');
            load();
        } catch (e) { toast.error('Error al guardar'); }
        finally { setBusy(false); }
    };

    return (
        <div className="space-y-4" data-testid="admin-factura-page">
            <div className="flex items-center gap-2"><Receipt className="h-6 w-6 text-red-600" /><h1 className="text-2xl font-semibold">Factura.com — CFDI 4.0</h1></div>
            {status && (
                <div className="flex items-center gap-2 text-sm">
                    Estado:{' '}<Badge className={status.configured ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}>{status.configured ? 'Configurado' : 'Sin configurar (modo simulación)'}</Badge>
                </div>
            )}
            <Card>
                <CardHeader><CardTitle>Credenciales</CardTitle></CardHeader>
                <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div className="md:col-span-2">
                        <Label>API Key</Label>
                        <Input type="password" value={settings.factura_com_api_key || ''} onChange={e => setSettings({...settings, factura_com_api_key: e.target.value})} placeholder="Deja vacío para no cambiar" data-testid="factura-api-key" />
                    </div>
                    <div className="md:col-span-2">
                        <Label>Secret Key</Label>
                        <Input type="password" value={settings.factura_com_secret_key || ''} onChange={e => setSettings({...settings, factura_com_secret_key: e.target.value})} placeholder="Deja vacío para no cambiar" data-testid="factura-secret-key" />
                    </div>
                    <div>
                        <Label>Modo</Label>
                        <Select value={settings.factura_com_mode || 'sandbox'} onValueChange={v => setSettings({...settings, factura_com_mode: v})}>
                            <SelectTrigger data-testid="factura-mode"><SelectValue /></SelectTrigger>
                            <SelectContent>
                                <SelectItem value="sandbox">Sandbox (pruebas)</SelectItem>
                                <SelectItem value="live">Producción</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label>Serie CFDI</Label>
                        <Input value={settings.factura_com_series || ''} onChange={e => setSettings({...settings, factura_com_series: e.target.value})} placeholder="OK" data-testid="factura-series" />
                    </div>
                    <div>
                        <Label>RFC del emisor</Label>
                        <Input value={settings.factura_com_issuer_rfc || ''} onChange={e => setSettings({...settings, factura_com_issuer_rfc: e.target.value.toUpperCase()})} placeholder="OKT210101ABC" data-testid="factura-rfc" />
                    </div>
                    <div>
                        <Label>Nombre / razón social emisor</Label>
                        <Input value={settings.factura_com_issuer_name || ''} onChange={e => setSettings({...settings, factura_com_issuer_name: e.target.value})} placeholder="OK TE LO VENDO SA DE CV" data-testid="factura-issuer-name" />
                    </div>
                    <div className="md:col-span-2 pt-2 flex justify-end">
                        <Button onClick={save} disabled={busy} className="bg-red-600 hover:bg-red-700" data-testid="factura-save">Guardar</Button>
                    </div>
                </CardContent>
            </Card>
            <div className="text-xs text-muted-foreground">
                Docs: <a href="https://factura.com/apidocs/" target="_blank" rel="noreferrer" className="underline">factura.com/apidocs</a>
            </div>
        </div>
    );
}
